import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

const VisibilityDropdown = ({ columns = [], toggleColumnVisibility }) => {
  const [visibility, setVisibility] = useState(
    columns.reduce((acc, column) => {
      acc[column.id] = column.getIsVisible();
      return acc;
    }, {}),
  );

  useEffect(() => {
    const newVisibility = columns.reduce((acc, column) => {
      acc[column.id] = column.getIsVisible();
      return acc;
    }, {});
    setVisibility(newVisibility);
  }, [columns]);

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleCheckboxChange = (columnId) => {
    setVisibility((prevVisibility) => {
      const updatedVisibility = {
        ...prevVisibility,
        [columnId]: !prevVisibility[columnId],
      };
      return updatedVisibility;
    });
  };

  const handleUpdate = () => {
    toggleColumnVisibility(visibility);
    setDropdownOpen(false);
  };

  return (
    <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)} className="pr-2">
      <DropdownToggle color="theme-green" title="Column Visibility" className="btn-md" caret>
        Column Visibility
      </DropdownToggle>
      <DropdownMenu>
        {columns.map((column) => (
          <DropdownItem
            key={column.id}
            className="d-flex align-items-center"
            toggle={false}
            onClick={() => handleCheckboxChange(column.id)}
          >
            <input
              name={column.id}
              type="checkbox"
              className="form-check-input"
              checked={visibility[column.id]}
              readOnly
              style={{
                transform: 'scale(1.2)',
              }}
            />
            <span className="ml-2">
              {typeof column.columnDef.header === 'function'
                ? column.columnDef.header()
                : column.columnDef.header || column.id}
            </span>
          </DropdownItem>
        ))}
        <div className="d-flex justify-content-end mr-2 mt-2">
          <button
            className="btn btn-theme-submit btn-sm"
            onClick={(e) => {
              e.stopPropagation();
              handleUpdate();
            }}
          >
            <i className="wb webconnect-save-regular"></i> Update
          </button>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default VisibilityDropdown;
